import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
    isLoadingUpdate: false,
  };

  const CategorysReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_Categorys_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_Categorys_success", (state,action) => {
        state.isLoading = false;
        state.AllCategorys = action.payload.categorys;
        state.totalcategorys=action.payload.totalcategorys;
        state.pagination=action.payload.pagination;
      
      })
      .addCase("get_all_Categorys_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_categorys_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_categorys_success", (state,action) => {
        state.isLoading = false;
        state.Filltercategorys = action.payload.categorys;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_categorys_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Categorys_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Categorys_success", (state,action) => {
        state.isLoading = false;
        state.CategoryData = action.payload;
      })
      .addCase("get_Categorys_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
    
      .addCase("clear_category", (state) => {
        state.err = false;
        state.DeleteMessage = false;
        state.Updatedcategory = false;

       state.isLoadingUpdate = false;
      
      

      });
      
  });
  
  export default CategorysReducer;